import React from 'react'

const ErrorPage = () => {
    return ( <h1>This site does not exist</h1> );
}
 
export default ErrorPage;